/**
 * In-memory session state — DEK and current user. The DEK NEVER leaves this
 * module's closure (no localStorage, no sessionStorage) so a page reload
 * intentionally drops it and forces a re-unlock with the password.
 *
 * Svelte 5 runes give us cheap reactivity without a separate store.
 */
import type { MeResponse } from '../../../shared/types';

interface State {
  user: MeResponse | null;
  dek: Uint8Array | null;
}

export const session = $state<State>({ user: null, dek: null });

export function setSession(user: MeResponse, dek: Uint8Array): void {
  session.user = user;
  session.dek = dek;
}

/**
 * Rehydrate the user identity from /me on page load. The DEK is intentionally
 * left null — it never persists across reloads. Callers needing private
 * decryption must run the full login flow to re-derive it.
 */
export function setSessionUserOnly(user: MeResponse): void {
  session.user = user;
  session.dek = null;
}

export function clearSession(): void {
  if (session.dek) {
    // Best-effort zeroisation. The buffer may have been copied internally by
    // libsodium before we get here, but we still wipe what we hold.
    session.dek.fill(0);
  }
  session.user = null;
  session.dek = null;
}
